<div 
  role="dialog" 
  [attr.aria-label]="'annotation.annotation_toolbar' | translate" 
  cdkTrapFocus 
  [cdkTrapFocusAutoCapture]="true" 
  rdrxHideOnEscape
  *ngIf="!isTranslationToolEngaged"
>
  <ul class="action-container" *ngIf="!onlyReadspeakerEnabled">
    <li class="underline-container" *ngIf="config.highlights">
      <button
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        id="add-annotation-highlight"
        data-automation-id="add-annotation-highlight"
        (click)="highlight('default')"
        [mheTooltip]="'context.add_highlight' | translate"
        placement="bottom"
        [attr.aria-pressed]="isHighlightPressed('default') | async"
      >
        <i class="dpg-icon dpg-icon-highlighter"></i>
      </button>
      <div [ngClass]="defaultClass$ | async"></div>
    </li>

    <li class="underline-container" *ngIf="config.highlights">
      <button
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        data-automation-id="add-annotation-underline"
        (click)="highlight('underline')"
        [mheTooltip]="'context.add_underline' | translate"
        placement="bottom"
        [attr.aria-pressed]="isHighlightPressed('underline') | async"
      >
        <i class="dpg-icon dpg-icon-keyboard-letters-underline"></i>
      </button>
      <div [ngClass]="underlineClass$ | async"></div>
    </li>

    <li class="underline-container" *ngIf="config.highlights">
      <button
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        data-automation-id="add-annotation-box"
        (click)="highlight('box')"
        [mheTooltip]="'context.add_box' | translate"
        placement="bottom"
        [attr.aria-pressed]="isHighlightPressed('box') | async"
      >
        <i class="dpg-icon dpg-icon-keyboard-letters-rectangle"></i>
      </button>
      <div [ngClass]="boxClass$ | async"></div>
    </li>

    <li class="underline-container" *ngIf="config.highlights">
      <button
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        data-automation-id="add-annotation-circle"
        (click)="highlight('circle')"
        [mheTooltip]="'context.add_circle' | translate"
        placement="bottom"
        [attr.aria-pressed]="isHighlightPressed('circle') | async"
      >
        <i class="dpg-icon dpg-icon-keyboard-letters-rectangle-rounded"></i>
      </button>
      <div [ngClass]="circleClass$ | async"></div>
    </li>

    <li class="underline-container" *ngIf="config.placemarks">
      <button
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        data-automation-id="placemark-toggle"
        (click)="placemark()"
        [mheTooltip]="
          (store.placemarkText$ | async)?.length > 0
            ? ('context.remove_placemark' | translate)
            : ('context.add_placemark' | translate)"
        placement="bottom"
        [attr.aria-pressed]="isPlacemarkPressed() | async"
      >
        <i class="placemark-icon"></i>
      </button>
      <div [class.underline-container-default]="(store.placemarkText$ | async)?.length > 0"></div>
    </li>

    <li class="underline-container" *ngIf="config.notes">
      <button
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        data-automation-id="add-note"
        (click)="store.showOptionsPane('note') ; focusTextArea()"
        [mheTooltip]="
          (store.note$ | async)?.length > 0
            ? ('context.edit_note' | translate)
            : ('context.add_note' | translate)
        "
        placement="bottom"
        [attr.aria-pressed]="(store.visibleOptionsPane$ | async) === 'note'"
      >
        <i class="ahe-icon dpg-icon-notepad"></i>
      </button>
      <div
        [class.underline-container-default]="
          (store.note$ | async)?.length > 0 || (store.visibleOptionsPane$ | async) === 'note'
        "
      ></div>
    </li>

    <li class="readspeaker-icon" *ngIf="config.readspeaker">
      <button
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        data-automation-id="read-selected-text"
        (click)="onLoadAudioText()"
        [mheTooltip]="'readspeaker.read_selected' | translate"
        placement="bottom"
        [attr.aria-pressed]="isReadspeakerPressed() | async"
      >
        <i class="dpg-icon dpg-icon-audioon"></i>
      </button>
    </li>

    <li class="underline-container ai-assist" *ngIf="config.isAiAssistOffered" >
      <button
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        data-automation-id="ai-assist"
        (click)="onClickAiAssist()"
        [mheTooltip]="'ai_assist.button' | translate"
        placement="bottom"
        [attr.aria-pressed]="isAiAssistPressed() | async"
      >
        <i class="ai-assist ai-assist-icon"></i>
      </button>
      <!-- only show BETA badge if in FA4 context -->
      <span *ngIf="(config$ | async)?.topicsEndpoint" class="badge">BETA</span>
    </li>

    <li class="underline-container" *ngIf="config.isTranslationOffered">
      <button
        #translationButton
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        data-automation-id="translation-tool"
        [mheTooltip]="'translation_tool.button' | translate"
        placement="bottom"
        (click)="openTranslationTool()"
        [attr.aria-pressed]="isTranslationToolEngaged"
      >
        <i class="translation translation-icon" aria-hidden="true"></i>
      </button>
    </li>

    <li>
      <button
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        class="action"
        data-automation-id="context-menu-close"
        (click)="close()"
        [mheTooltip]="'navigation.close' | translate"
        placement="bottom"
        cdkFocusInitial
      >
        <i class="dpg-icon dpg-icon-system-close"></i>
      </button>
    </li>
  </ul>

  <div class="highlight-selection-pane" *ngIf="(store.visibleOptionsPane$ | async) === 'color'">
    <ul class="highlight-selection-pane__colors">
      <ng-container *ngFor="let colorOptionWithTooltip of colorOptionsWithTooltip$ | async">
        <li>
          <button
            mhe-button
            [purpose]="ButtonPurpose.Icon"
            class="color-button"
            (click)="store.setHighlightColor(colorOptionWithTooltip.highlightColor)"
            [mheTooltip]="colorOptionWithTooltip.tooltip"
            [attr.aria-pressed]="(store.highlightColor$ | async) === colorOptionWithTooltip.highlightColor"
          >
            <rdrx-color-icon
              [id]="colorOptionWithTooltip.highlightColor+'-icon'"
              [color]="colorOptionWithTooltip.highlightColor"
              [selected]="(store.highlightColor$ | async) === colorOptionWithTooltip.highlightColor"
            ></rdrx-color-icon>
          </button>
        </li>
      </ng-container>
    </ul>
    <div *ngIf="!isTouchScreen" class="highlight-selection-pane__quick-annotation">
      <rdrx-quick-annotation></rdrx-quick-annotation>
    </div>
  </div>

  <div
    [class.tts-audio-controls-pane]="!onlyReadspeakerEnabled"
    *ngIf="(store.visibleOptionsPane$ | async) === 'readspeaker'"
  >
    <div *ngIf="showLoading$ | async" class="tts-spinner-container">
      <mat-progress-spinner
        class="rdrx-spinner annotation-toolbar-tts-spinner"
        data-automation-id="annotation-toolbar-tts-spinner"
        [mode]="'indeterminate'"
        [diameter]="30"
        [attr.aria-label]="'readspeaker.buffering' | translate"
      ></mat-progress-spinner>
    </div>
    <rdrx-audio-controls
      *ngIf="(showLoading$ | async) === false"
      class="annotation-toolbar-tts-audio-controls"
      data-automation-id="annotation-toolbar-tts-audio-controls"
      [audioContext]="TTSAudioContext.HIGHLIGHT"
      [showClose]="onlyReadspeakerEnabled"
      (closeEvent)="close()"
    >
    </rdrx-audio-controls>
  </div>

  <div class="note-pane" *ngIf="(store.visibleOptionsPane$ | async) === 'note'">
    <mhe-textarea
      #mheTextArea
      class="note-input"
      data-automation-id="note-input"
      [value]="store.note$ | async"
      (inputChange)="noteChanged($event)"
      [maxlength]="store.noteMaxCharacters$ | async"
      [rows]="undefined"
    ></mhe-textarea>
    <div class="character-counter">
      {{ (store.note$ | async)?.length || '0' }} / {{ store.noteMaxCharacters$ | async }}
    </div>
  </div>
</div>

<rdrx-translation-tool-shell
  *ngIf="isTranslationToolEngaged"
  role="dialog"
  cdkTrapFocus
  cdkTrapFocusAutoCapture
  rdrxHideOnEscape
  [selectedText]="annotation.text"
  (closeRequested)="disengageTranslationTool()"
></rdrx-translation-tool-shell>
